<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="62.5%"
      top="20vh"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :append-to-body="false"
      :center="true">
      <div class="content">
        <div v-if="active!=2" class="stepContent">
          <el-steps :active="active" class="stepMaincenter" :align-center="true">
            <el-step title="手机号验证"></el-step>
            <el-step title="重置密码"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </div>

        <!-- 手机号验证 -->
        <div v-if="active === 0" class="step1">
          <el-form ref="confirmForm" :model="confirmForm" :rules="rules">
            <el-form-item label="手机号" prop="phoneNumber">
              <el-input v-model="confirmForm.phoneNumber" placeholder="请输入手机号" size="middle" maxlength="11"
                        @keyup.native="confirmForm.phoneNumber = confirmForm.phoneNumber.replace(/[^\d]/g,'')">
              </el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input v-model="confirmForm.code" placeholder="验证码" type="code" size="middle" auto-complete="new-password" maxlength="6">
                <span
                  v-show="sendAuthCode"
                  slot="suffix" class="get-code"
                  @click.prevent="getAuthCode">
                  获取验证码
                </span>
                <span v-show="!sendAuthCode" slot="suffix" class="get-code ft-gray" disabled>
                  {{ auth_time }} 秒之后重新发送
                </span>
              </el-input>
            </el-form-item>
          </el-form>
          <el-button class="btn-next" :style="{backgroundColor: (confirmForm.phoneNumber.length> 0 && confirmForm.code.length > 0? '#3269FF':'#c4c4c4')}" @click="handleConfirm">下一步</el-button>
        </div>

        <!-- 重置密码 -->
        <div v-if="active === 1" class="step2">
          <el-form ref="setForm" :model="setForm" :rules="rules">
            <el-form-item label="新密码" prop="password" class="password">
              <el-input v-model="setForm.password" type="password" auto-complete="new-password" minlength="8" maxlength="20" placeholder="输入8-20位密码，至少包含数字和字母"></el-input>
              <img v-if="passFlag" src="https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/background-img/pass.svg" alt="" class="password-pass">
            </el-form-item>

            <el-form-item label="确认密码" prop="checkPass" class="password">
              <el-input v-model="setForm.checkPass" type="password" auto-complete="new-password" minlength="8" maxlength="20" placeholder="请再次输入密码"></el-input>
              <img v-if="checkPassFlag" src="https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/background-img/pass.svg" alt="" class="password-pass">
            </el-form-item>
          </el-form>
          <el-button class="btn-next" :style="{backgroundColor: (setForm.password.length> 0 && setForm.checkPass.length > 0? '#3269FF':'#c4c4c4')}" @click="handleSetPass">重置密码</el-button>
        </div>
        <div v-if="active === 2" class="step3">
          <p class="title">{{ title }}</p>
          <img src="https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/background-img/success.svg" alt="">
          <p class="success">密码设置成功！</p>
          <p class="tips">您的密码已设置成功，请牢记您的密码。</p>
          <el-button class="btn-next" @click="toLogin">立即登录</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCodeApi,
  checkPhoneCodeApi,
  setPasswordApi,
} from './fetch'
export default {
  name: '',
  components: {
  },
  props: {
    title: {
      type: String,
    },
  },
  data () {
    // 手机号校验
    const validPhone = (rules, value, callback) => {
      if (!value) callback()
      if (/^1\d{10}$/g.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确手机号'))
      }
    }
    const validatePass = (rule, value, callback) => {
      const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,20}$/

      this.passFlag = false
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!reg.test(value)) {
        callback(new Error('密码必须由8-20位 至少包含数字和字母'))
      } else {
        if (this.setForm.checkPass !== '') {
          // 对第二个密码框单独验证
          this.$refs.setForm.validateField('checkPass')
        }
        this.passFlag = true
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      this.checkPassFlag = false
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.setForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        this.checkPassFlag = true
        callback()
      }
    }
    const validCode = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else if (!this.checkCodeFlag) {
        callback(new Error('验证码有误'))
      } else {
        callback()
      }
    }

    return {
      active: 0,
      dialogVisible: true,
      auth_time: 0,
      sendAuthCode: true,
      confirmForm: {
        phoneNumber: '',
        code: '',
      },
      setForm: {
        password: '',
        checkPass: '',
      },
      rules: {
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: ['change', 'blur'] },
          { validator: validPhone, trigger: ['change', 'blur'] },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: ['change', 'blur'] },
          { validator: validCode, trigger: ['change', 'blur'] },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: ['change', 'blur'] },
          { validator: validatePass, trigger: ['change', 'blur'] },
        ],
        checkPass: [
          { required: true, message: '请再次输入密码', trigger: ['change', 'blur'] },
          { validator: validatePassCheck, trigger: ['change', 'blur'] },
        ],

      },

      passFlag: false,
      checkPassFlag: false,
      checkCodeFlag: true,

    }
  },
  computed: {
  },
  watch: {
    'confirmForm.code' () {
      this.checkCodeFlag = true
    },
  },
  created () {
  },
  methods: {
    next () {
      if (this.active++ > 2) this.active = 0
      this.$nextTick(() => {
        if (this.active === 1) {
          this.$refs.setForm.clearValidate()
        }
      })
    },
    toLogin () {
      this.$emit('close')
      window.location.href = '/login'
    },
    // 获取验证码
    async getAuthCode () {
      try {
        // 请求验证码
        const phoneNumber = this.confirmForm.phoneNumber
        await getCodeApi({
          phoneNumber,
          messageType: 'changepassword',
          systemDomain: 'dev',
        })
        this.sendAuthCode = false
        this.auth_time = 60
        const timer = setInterval(() => {
          this.auth_time--
          if (this.auth_time <= 0) {
            this.sendAuthCode = true
            clearInterval(timer)
          }
        }, 1000)
      } catch (e) {
        this.$error(e)
      }
    },
    // 下一步 校验
    async handleConfirm () {
      try {
        await this.$refs.confirmForm.validate()

        // 校验输入合法性 及接口返回状态判断是否 进入下一步
        const res = await checkPhoneCodeApi({
          ...this.confirmForm,
          messageType: 'changepassword',
        })
        if (!res) {
          this.checkCodeFlag = false
          this.$refs.confirmForm.validateField('code')
          return
        }
        this.next()
      } catch (e) {
        this.$error(e)
      }
    },
    // 重置密码
    async handleSetPass () {
      try {
        await this.$refs.setForm.validate()
        await setPasswordApi({
          ...this.confirmForm,
          userPassword: this.setForm.password,
          systemDomain: 'dev',
        })
        this.next()
      } catch (e) {
        this.$error(e)
      }
    },
    handleClose () {
      this.$emit('close')
    },
  },
}
</script>

<style lang='scss' scoped>
  .content {
    padding: 60px 0 ;
    margin: 0 auto;
    width: 980px;
    .stepContent {
      margin-bottom: 20px;
      // 步骤条颜色设置
      ::v-deep .el-steps{
        .el-step__title {
          font-size: 14px;
        }
        .el-step__icon {
           border: none;
           font-size: 12px;
        }
        .is-process, .is-finish {
          color:#1C1C1C;
          font-weight: Bold;
          .el-step__icon {
            color: #fff;
            background-color: #3269FF;
          }
        }
        .is-finish {
          .el-step__line {
            background-color: #3269FF;
            border-color: #3269FF;
          }
        }
        .is-wait{
          .el-step__icon {
            background-color: #e8e8e8;
            color: #C4C4C4;
          }

        }

      }
    }
    .step1 {
      width: 360px;
      text-align: center;
      margin: 0 auto;
     ::v-deep .el-input__suffix {
        right: 10px;
        .get-code {
          line-height: 46px;
          color:#3269FF;
          cursor: pointer;
        }
      }

    }
    .step2 {
      width: 360px;
      text-align: center;
      margin: 0 auto;
      .password {
        position: relative;
        &-pass {
          position: absolute;
          right: -30px;
          top: 46px;
        }
      }
    }
    .step3 {
      width: 100%;
      text-align: center;
      margin: 0 auto;
      .title {
        margin-bottom: 52px;
        font-size: 40px;
        color: #1C1C1C;
        font-weight: bold;
      }
      .success {
        margin: 30px 0 10px;
        font-size: 20px;
        font-weight: bold;
      }
      .tips {
        color: #3269FF;
      }
    }
    .btn-next {
      margin-top: 40px;
      height: 46px;
      width: 360px;
      border: none;
      cursor: pointer;
      color: #fff;
      border-radius: 2px;
      font-size: 16px;
      background-color: #3269FF;
    }

  }
  ::v-deep .el-dialog__wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  ::v-deep .el-dialog{
    margin: auto !important;
    .el-dialog__headerbtn{
      width: 24px;
      height: 24px;
      background: #E8E8E8;
      border-radius: 50%;
    }
  }
</style>
